<template>
  <div style="gap: 20px">
    <v-card
      flat
      :style="{
        borderBottom: '3px solid #272727',
        borderLeft: '1px solid #272727',
        borderTop: '1px solid #272727',
        borderRight: '3px solid #272727',
        borderRadius: '8px',
      }"
      style="height: calc(100vh - 150px)"
      class="calendarcard"
    >
      <v-window v-model="window" v-if="!loading.calendar">
        <v-window-item v-for="(n, i) in calendar" :key="i">
          <div class="calendar">
            <div class="day" v-for="(d, index) in n.days" :key="index">
              <div>
                <div class="day-title" :class="{ today: d.today }">
                  <span> {{ d.text }}</span>
                </div>
                <v-divider></v-divider>
              </div>

              <div class="pa-2">
                <v-btn
                  elevation="0"
                  size="small"
                  text
                  v-if="!d.past || d.today"
                  block
                  @click="addScheduledPost(d.unix)"
                  >Add post</v-btn
                >
              </div>
              <div class="px-2 posts" v-if="!loading.calendar">
                <div v-for="p in d.posts" :key="p.uid">
                  <Post :post="p" v-if="showPost(p)" :calendar_uid="d.uid" />
                </div>
              </div>
            </div>
          </div>
        </v-window-item>
      </v-window>

      <div v-else>
        <div class="calendar">
          <div class="day">
            <v-skeleton-loader
              type="image, text, text"
              width="100%"
              height="200"
            />
          </div>
          <div class="day"></div>
          <div class="day">
            <v-skeleton-loader
              type="image, text, text"
              width="100%"
              height="200"
            />
          </div>
          <div class="day"></div>
          <div class="day"></div>
          <div class="day"></div>
          <div class="day">
            <v-skeleton-loader
              type="image, text, text"
              width="100%"
              height="200"
            />
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Post from "@/components/post/CalendarPostCard.vue";
import { DateTime } from "luxon";

export default {
  components: {
    Post,
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      loading: (state) => state.loading,
      calendar: (state) => state.schedules.calendar,
      week: (state) => state.schedules.week,
      accounts: (state) => state.accounts.accounts,
      categories: (state) => state.posts.categories,
      window: (state) => state.schedules.window,
    }),
  },
  data() {
    return {
      selected_accounts: [],
      category: null,
    };
  },
  methods: {
    addScheduledPost(unix) {
      const originalDateTime = DateTime.fromMillis(unix * 1000);
      const now = DateTime.local();
      const currentHour = now.hour;
      const currentMinute = now.minute;
      const adjustedDateTime = originalDateTime.set({
        hour: currentHour,
        minute: currentMinute,
        second: 0,
        millisecond: 0,
      });

      let u = adjustedDateTime.toSeconds();
      this.$store.commit("setPostScheduleDate", u);
      this.$store.commit("setPostSheet", true);
    },
    previous() {
      this.$store.commit("previousWeek");
    },
    next() {
      this.$store.commit("nextWeek");
    },
    showPost(p) {
      if (this.selected_accounts.length === 0 && !this.category) {
        return true;
      } else if (this.category && this.selected_accounts.length === 0) {
        return p.category === this.category.uid;
      } else if (!this.category && this.selected_accounts.length > 0) {
        let show = false;

        this.selected_accounts.forEach((a) => {
          p.post &&
            p.post.accounts.forEach((pa) => {
              if (pa.id === a.id) {
                show = true;
              }
            });
        });
        return show;
      } else if (this.category && this.selected_accounts.length > 0) {
        let show = false;

        this.selected_accounts.forEach((a) => {
          p.post.accounts.forEach((pa) => {
            if (pa.id === a.id && p.post.category === this.category.uid) {
              show = true;
            }
          });
        });

        return show;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.calendar {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  grid-auto-flow: column;
  height: calc(100vh - 130px);

  div:last-child {
    border-right: none;
  }

  .day {
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    max-width: 100%;

    .day-title {
      background-color: #f0f0f0;
      text-align: center;
      padding: 10px 0;
      font-weight: 500;
      font-size: 14px;
      position: sticky;
      top: 64px;
      z-index: 3;
      border-bottom: 1px solid #272727;

      &.today {
        font-weight: 700;

        span {
          margin: 0 -0.4em;
          padding: 0.2em 1em;
          border-radius: 0.8em 0.3em;
          background: transparent;
          background-image: linear-gradient(
            to right,
            rgba(207, 184, 255, 0.1),
            rgba(207, 184, 255, 0.7) 4%,
            rgba(207, 184, 255, 0.3)
          );
          -webkit-box-decoration-break: clone;
          box-decoration-break: clone;
        }
      }
    }

    .posts {
      display: flex;
      gap: 20px;
      flex-direction: column;
      padding-bottom: 50px;
      height: calc(100vh - 230px);
      overflow: auto;
    }
  }
}
</style>
